




























































import Component from 'vue-class-component';
import {IDictionary} from '@/entities/dictionary.interface';
import {IFormControl} from '@/entities/form.interface';
import {EditPage} from '@/components/base/edit/edit-page';
import officesApi from '@/api/offices.api';
import {IListItem} from '@/entities/list-item.interface';
import sitesApi from '@/api/sites.api';
import preferredDomainsApi from '@/api/preferred-domain.api';
import {IOfficeDetail} from '@/entities/offices/office-detail.interface';
import {mapGetters} from 'vuex';
import * as types from '@/store/types';
import PreferredDomainMasterPage from '@/containers/account/offices/preferred-domain.vue';
import {IPreferredDomain} from '@/entities/preferred-domains';

@Component({
    computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
    })
})
export default class PreferredDomainEditPage extends EditPage {
    public parentPath: string = '/app/offices/domains';

    public formState: IDictionary<IFormControl> = {
        domain: {
            key: 'domain',
            label: 'domain',
            value: 'https://',
            validators: 'required'
        },
        description: {
            key: 'description',
            label: `Note`,
            value: ''
        },
        hidden: {
            key: 'hidden',
            label: `Hidden`,
            value: false
        }
    };

    public async created() {
        await super.created();
        if (this.isNew) {
            this.formState = {
                ...this.formState
            };
        }
    }

    // TODO own resourse service will be nice for api calls
    public detail(id: number): Promise<IPreferredDomain> {
        return preferredDomainsApi.get(id);
    }

    public create(body: any): Promise<number> {
        return preferredDomainsApi.create(body);
    }

    public update(body: any): Promise<number> {
        return preferredDomainsApi.update(this.id, body);
    }

}
